function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M17.28 11.2c-.19 0-.38-.07-.53-.22a.755.755 0 010-1.06l3.19-3.19-3.19-3.19a.754.754 0 010-1.06c.29-.29.77-.29 1.06 0l3.72 3.72a.75.75 0 010 1.06l-3.72 3.72c-.15.14-.34.22-.53.22z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21 7.48H3c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h18c.41 0 .75.34.75.75s-.34.75-.75.75zM6.72 21.75c-.19 0-.38-.07-.53-.22l-3.72-3.72a.75.75 0 010-1.06l3.72-3.72c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-3.19 3.19 3.19 3.19c.29.29.29.77 0 1.06a.71.71 0 01-.53.22z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21 18.02H3c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h18c.41 0 .75.34.75.75s-.34.75-.75.75z"
})));